










import i18n from "@/plugins/i18n";
import Utils from "@/utils";
import Vue from "vue";
import storeHelper from "../../store/store-helper";
export default Vue.extend({
    name: "ToolbarHelp",
    data: () => {
        return {
            communityButtonTryCount: 0,
            isCommunityButtonRendering: false,
            customHelpPageUrl: null
        };
    },
    async created() {
        this.customHelpPageUrl = await storeHelper.settingsStore.getSettingAsync<string>("custom_help_page_url");
    },
    computed: {
        userLanguage(): string {
            return i18n.locale;
        },
        communityScriptUrl(): string {
            if (this.userLanguage == "nl") {
                return "//embeddable-widgets.insided.com/infoland-nl.insided-conversational.js";
            } else {
                return "//embeddable-widgets.insided.com/infoland-en.insided-conversational.js";
            }
        },
        routePath(): string {
            return this.$route.path;
        },
        communitySite(): string {
            if (this.userLanguage == "nl") {
                return "https://community.infoland.nl";
            } else {
                return "https://community.infoland.eu";
            }
        }
    },
    watch: {
        routePath: function () {
            if (this.communityWidget() && this.communityButton()) {
                this.communityButton().click();
            }
        },
        userLanguage: function () {
            if (this.communityButton()) {
                this.communityButton().parentNode.removeChild(this.communityButton());
                this.communityButtonTryCount = 0;
            }
        }
    },
    methods: {
        communityButton(): HTMLElement {
            return document.querySelector(".insided-conversational-trigger-button");
        },
        communityWidget(): HTMLElement {
            return document.querySelector(".insided-conversational-slider--open");
        },
        async helpButtonClicked(): Promise<void> {
            if (this.customHelpPageUrl && this.customHelpPageUrl.length > 0) {
                window.open(this.customHelpPageUrl, "_blank");
            } else {
                try {
                    // log event for clicking on help button for community (but don't wait for it)
                    Utils.insertEventAsync("HelpButtonForCommunityClicked");
                } catch {
                    // eat error
                }
                await this.communityButtonClicked();
            }
        },
        async communityButtonClicked(): Promise<void> {
            if (!this.isCommunityButtonRendering) {
                if (!this.communityButton()) {
                    this.isCommunityButtonRendering = true;
                    let firstInlineScript: HTMLScriptElement = document.getElementsByTagName("script")[0];
                    let createScriptElement: HTMLScriptElement = document.createElement("script");
                    createScriptElement.src = this.communityScriptUrl;

                    firstInlineScript.parentNode.insertBefore(createScriptElement, firstInlineScript);
                    this.waitForCommunityButton();
                } else {
                    this.communityButton().click();
                }
            }
        },
        waitForCommunityButton(): void {
            if (this.communityButtonTryCount <= 25) {
                this.communityButtonTryCount++;
                if (this.communityButton()) {
                    this.isCommunityButtonRendering = false;
                    this.communityButton().click();
                } else {
                    setTimeout(this.waitForCommunityButton, 200);
                }
            } else {
                window.open(this.communitySite, "_blank");
                this.isCommunityButtonRendering = false;
            }
        }
    }
});
